var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBuilding(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 50,
    viewBox: "0 0 34 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5502 12.2269C19.9191 12.2269 22.6637 9.48228 22.6637 6.11346C22.6637 2.74463 19.9191 0 16.5502 0C13.1814 0 10.4368 2.74463 10.4368 6.11346C10.4368 9.48228 13.1814 12.2269 16.5502 12.2269ZM12.906 5.08537H15.5221V2.46925H17.5783V5.08537H20.1944V7.14155H17.5783V9.75767H15.5221V7.14155H12.906V5.08537Z",
    fill: "#333D6C",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2925 48.3478V12.9964C31.2925 11.3395 29.9493 9.99636 28.2925 9.99636H23.6185C22.2416 12.484 19.5888 14.1822 16.5504 14.1822C13.512 14.1822 10.8592 12.4932 9.48228 9.99636H4.80833C3.15148 9.99636 1.80833 11.3395 1.80833 12.9964V48.3478H0V50H33.11V48.3478H31.2925ZM23.2054 19.2859H27.4738V23.5543H23.2054V19.2859ZM23.2054 28.0797H27.4738V32.3481H23.2054V28.0797ZM14.4116 19.2859H18.68V23.5543H14.4116V19.2859ZM14.4116 28.0797H18.68V32.3481H14.4116V28.0797ZM5.61777 19.2859H9.88617V23.5543H5.61777V19.2859ZM5.61777 28.0797H9.88617V32.3481H5.61777V28.0797ZM11.3365 48.3478V39.4254H15.9996V48.3478H11.3365ZM17.092 48.3478V39.4254H21.7551V48.3478H17.092Z",
    fill: "#333D6C",
    fillOpacity: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBuilding);
export default __webpack_public_path__ + "static/media/icon-building.f566bc8fc83735c262b84b459c58ff9f.svg";
export { ForwardRef as ReactComponent };